import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource, } from "@angular/material";
import pdfMake from "pdfmake/build/pdfmake";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import * as moment from "moment";
import { CustomDateComponent } from "../reports/customdate/custom-date.component";
var PenaltyComponent = /** @class */ (function () {
    function PenaltyComponent(http, injectedTransformerId, datePipe, matDialog, transMngSer, ngxLoader) {
        this.http = http;
        this.injectedTransformerId = injectedTransformerId;
        this.datePipe = datePipe;
        this.matDialog = matDialog;
        this.transMngSer = transMngSer;
        this.ngxLoader = ngxLoader;
        this.idFilter = "";
        this.filter = {};
        this.downloadMessage = "Downloading...";
        this.sitename = [];
        this.totalPenalty = 0;
        this.transformerId = [];
        this.timeOptions = [
            "Today",
            "Yesterday",
            "This Week",
            "This Month",
            "Last Month",
            "Custom",
        ];
        this.selectedId = "";
        this.showAlert = false;
        this.preferredColumns = [
            "reading_time",
            "transformer_id",
            "actual_pf",
            "threshold_pf",
            "penalty",
            "loadPercentage",
            "Average_Voltage",
            "R_Ph_N",
            "Y_Ph_N",
            "B_Ph_N",
            "L1",
            "L2",
            "L3",
            "LN",
            "System_kwh"
        ];
        this.ddlData = [];
    }
    PenaltyComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, defaultValue;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getDdlData()];
                    case 1:
                        _a.transformerId = _b.sent();
                        this.sitename = this.ddlData.map(function (a) { return a.sitename; });
                        if (this.transformerId.length > 0) {
                            this.timeFilter = "Today";
                            defaultValue = this.transformerId[0];
                            this.filters("transformerId", defaultValue);
                            this.filters("date", "Today");
                        }
                        if (this.injectedTransformerId) {
                            this.filters("transformerId", this.injectedTransformerId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PenaltyComponent.prototype.getDdlData = function () {
        var _this = this;
        this.transMngSer
            .getTransformerData(JSON.parse(localStorage.getItem("userData")).roleid, JSON.parse(localStorage.getItem("userData")).userid, "report")
            .toPromise()
            .then(function (response) {
            console.log("DDL:", response.data);
            if (response.data.length > 0) {
                _this.ddlData = response.data;
                _this.transformerId = _this.ddlData.map(function (item) { return ({
                    serialnumber: item.serialnumber,
                    sitename: item.sitename,
                }); });
                _this.idFilter = _this.transformerId[0].serialnumber;
            }
            else {
                _this.transformerId = [];
            }
        });
    };
    PenaltyComponent.prototype.getHeaderName = function (col) {
        switch (col) {
            case "transformer_id":
                return "Transformer Id";
            case "site_name":
                return "Site Name";
            case "reading_time":
                return "Timestamp";
            case "actual_pf":
                return "Actual PF";
            case "threshold_pf":
                return "Threshold PF";
            case "loadPercentage":
                return "Load (%)";
            case "penalty":
                return "Penalty";
            case "Average_Voltage":
                return "Average Voltage (V)";
            case "R_Ph_N":
                return "R-N Voltage (V)";
            case "Y_Ph_N":
                return "Y-N Voltage (V)";
            case "B_Ph_N":
                return "B-N Voltage (V)";
            case "RY_Voltage":
                return "R-Y Voltage (V)";
            case "YB_Voltage":
                return "Y-B Voltage (V)";
            case "BR_Voltage":
                return "B-R Voltage (V)";
            case "L1":
                return "R - Current (A)";
            case "L2":
                return "Y - Current (A)";
            case "L3":
                return "B - Current (A)";
            case "LN":
                return "N - Current (A)";
            case "System_kwh":
                return "Active(kWh)";
            default:
                return col;
        }
    };
    PenaltyComponent.prototype.generateReport = function () {
        var _this = this;
        if (!this.unitCost) {
            this.showAlert = true;
            this.alertMessage = "Please enter the Unit Cost before proceeding.";
            return;
        }
        if (!this.timeFilter) {
            this.showAlert = true;
            this.alertMessage = 'Please select a Duration before proceeding.';
            return;
        }
        this.totalPenalty = 0;
        this.ngxLoader.start();
        var requestData = {
            transformerId: this.idFilter,
            unitCost: this.unitCost,
        };
        if (this.filter.filter)
            requestData.filter = this.filter.filter;
        if (this.filter.date)
            requestData.date = this.filter.date;
        if (this.filter.startDate)
            requestData.startDate = this.filter.startDate;
        if (this.filter.endDate)
            requestData.endDate = this.filter.endDate;
        console.log("Payload being sent:", requestData);
        this.transMngSer.pfPenalty(requestData).subscribe({
            next: function (response) {
                console.log("Backend response:", response);
                if (response.data && response.data.length > 0) {
                    _this.data = response.data.map(function (item) {
                        if (item.reading_time) {
                            item.reading_time = _this.datePipe.transform(item.reading_time, "dd-MM-yyyy HH:mm:ss");
                        }
                        return item;
                    });
                    _this.data = response.data;
                    _this.reportColumns = _this.preferredColumns.filter(function (col) {
                        return Object.keys(_this.data[0]).includes(col);
                    });
                    _this.dataSource = new MatTableDataSource(_this.data);
                    _this.dataSource.paginator = _this.paginator;
                    _this.dataSource.sort = _this.sort;
                    _this.totalPenalty = _this.data.reduce(function (sum, item) { return sum + (Number(item.penalty) || 0); }, 0);
                }
                else {
                    _this.data = [];
                    _this.dataSource = new MatTableDataSource([]);
                    _this.totalPenalty = 0;
                }
                _this.ngxLoader.stop();
            },
            error: function (err) {
                console.error("Error:", err);
                _this.totalPenalty = 0;
                _this.dataSource = new MatTableDataSource([]);
                _this.reportColumns = [];
                _this.ngxLoader.stop();
            },
        });
    };
    PenaltyComponent.prototype.closeAlert = function () {
        this.showAlert = false;
    };
    PenaltyComponent.prototype.filters = function (type, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(type, value);
                        if (type === "transformerId") {
                            this.idFilter = value.split("[")[0];
                            this.filter.transformerId = this.idFilter;
                            this.selectedId = value;
                            this.selectedSite = this.ddlData.filter(function (a) { return a.serialnumber === _this.idFilter; });
                            if (this.selectedSite.length > 0) {
                                this.city = this.selectedSite[0].City;
                                this.location = this.selectedSite[0].Location;
                                this.selectedSite = this.selectedSite[0].sitename;
                            }
                        }
                        if (!(type === "date")) return [3 /*break*/, 2];
                        this.timeFilter = value;
                        return [4 /*yield*/, this.formatDate(value)];
                    case 1:
                        filter = _a.sent();
                        if (filter.filter === "This Week" ||
                            filter.filter === "This Month" ||
                            filter.filter === "Last Month") {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            this.filter.startDate = filter.startDate;
                            this.filter.endDate = filter.endDate;
                            this.filter.filter = filter.filter;
                        }
                        else if (filter.filter === "Today" || filter.filter === "Yesterday") {
                            if (this.filter && this.filter.startDate && this.filter.endDate) {
                                delete this.filter.startDate;
                                delete this.filter.endDate;
                            }
                            this.filter.date = filter.date;
                            this.filter.filter = filter.filter;
                        }
                        else if (filter.filter === "Custom") {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            if (filter.startDate && filter.endDate) {
                                this.filter.startDate = filter.startDate;
                                this.filter.endDate = filter.endDate;
                                this.filter.filter = filter.filter;
                            }
                        }
                        if (filter.startDate && filter.endDate) {
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PenaltyComponent.prototype.formatDate = function (value) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (value === "Today") {
                var d = new Date(), month = "" + (d.getMonth() + 1), day = "" + d.getDate(), year = d.getFullYear();
                if (month.length < 2)
                    month = "0" + month;
                if (day.length < 2)
                    day = "0" + day;
                resolve({ date: [year, month, day].join("-"), filter: value });
            }
            else if (value === "Yesterday") {
                var d = new Date(), month = "" + (d.getMonth() + 1), day = "" + (d.getDate() - 1), year = d.getFullYear();
                if (month.length < 2)
                    month = "0" + month;
                if (day.length < 2)
                    day = "0" + day;
                resolve({ date: [year, month, day].join("-"), filter: value });
            }
            else if (value === "Last Month") {
                resolve({
                    startDate: moment()
                        .subtract(1, "months")
                        .startOf("month")
                        .format("YYYY-MM-DD"),
                    endDate: moment()
                        .subtract(1, "months")
                        .endOf("month")
                        .format("YYYY-MM-DD"),
                    filter: value,
                });
            }
            else if (value === "This Month") {
                resolve({
                    startDate: moment().startOf("month").format("YYYY-MM-DD"),
                    endDate: moment().endOf("month").format("YYYY-MM-DD"),
                    filter: value,
                });
            }
            else if (value === "This Week") {
                resolve({
                    startDate: moment().startOf("week").format("YYYY-MM-DD"),
                    endDate: moment().endOf("week").format("YYYY-MM-DD"),
                    filter: value,
                });
            }
            else if (value === "Custom") {
                console.log("Custom filter:", value);
                var dialogConfig = new MatDialogConfig();
                var dialogRef = _this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: "350px",
                    width: "450px",
                    data: {
                        details: "",
                        action: "Add",
                        selectedDate: _this.customeSelectedDate,
                    },
                });
                dialogRef.afterClosed().subscribe(function (selectedDate) {
                    _this.customeSelectedDate = selectedDate;
                    if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
                        resolve({
                            startDate: selectedDate.startDate,
                            endDate: selectedDate.endDate,
                            filter: "Custom",
                        });
                    }
                });
            }
        });
    };
    PenaltyComponent.prototype.formatData = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataArr = [];
            dataArr.push(_this.reportColumns);
            data.forEach(function (element) {
                delete element.City;
                delete element.Location;
                dataArr.push(Object.values(element));
            });
            resolve(dataArr);
        });
    };
    PenaltyComponent.prototype.exportToExcel = function () {
        var sheetData = this.formatDataForExport();
        if (sheetData.length === 0) {
            console.warn("No data to export");
            return;
        }
        var worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        var workbook = {
            SheetNames: ["Penalty Report"],
            Sheets: { "Penalty Report": worksheet },
        };
        var excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        var blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        FileSaver.saveAs(blob, (this.idFilter || "Penalty_Report") + ".xlsx");
    };
    PenaltyComponent.prototype.formatDataForExport = function () {
        var _this = this;
        if (!this.data || !this.reportColumns || this.data.length === 0)
            return [];
        var header = this.reportColumns.map(function (col) { return _this.getHeaderName(col); });
        var rows = this.data.map(function (row) {
            return _this.reportColumns.map(function (col) { return (row[col] !== undefined ? row[col] : ""); });
        });
        return tslib_1.__spread([header], rows);
    };
    PenaltyComponent.prototype.exportToPdf = function () {
        var sheetData = this.formatDataForExport();
        if (sheetData.length === 0) {
            console.warn("No data to export");
            return;
        }
        var docDefinition = {
            info: { title: "Transformer Penalty Report" },
            pageOrientation: "landscape",
            pageSize: "A4",
            content: [
                {
                    text: "Transformer Penalty Report",
                    style: "header",
                    margin: [0, 0, 0, 10],
                },
                {
                    table: {
                        headerRows: 1,
                        widths: Array(sheetData[0].length).fill("*"),
                        body: sheetData,
                    },
                },
            ],
            styles: {
                header: { fontSize: 16, bold: true, alignment: "center" },
            },
        };
        pdfMake
            .createPdf(docDefinition)
            .download((this.idFilter || "Penalty_Report") + ".pdf");
    };
    PenaltyComponent.prototype.refreshData = function () {
        console.log("Refreshing data...");
        this.generateReport();
    };
    return PenaltyComponent;
}());
export { PenaltyComponent };
